import { createFileRoute } from '@tanstack/react-router'
import StatementsContainer from 'Royalty/containers/StatementsContainer'

export const Route = createFileRoute('/royalty/statements')({
    component: StatementsContainer,
})
